<template>
  <validated-form :message="fieldFormMessage" @submit="handleFormSubmit">
    <div v-if="!fieldId" class="form-group">
      <label>Select a Field</label>
      <multiselect
        v-model="activeFieldSelection"
        tag-placeholder="Select a field"
        placeholder="Select a field"
        label="name"
        track-by="id"
        :options="farmFields"
        @select="setActiveFieldId"
      />
    </div>

    <div class="form-group">
      <label>Services Provided</label>
      <multiselect
        v-model="serviceData.services"
        tag-placeholder="Add this as new service"
        placeholder="Search for a service"
        label="name"
        track-by="id"
        :options="activeServices"
        :multiple="true"
        :taggable="true"
      />
    </div>
    <div class="form-group">
      <label>Equipment Used</label>
      <multiselect
        v-model="serviceData.equipment"
        placeholder="Search for an equipment"
        label="name"
        track-by="id"
        :options="activeEquipment"
        :multiple="true"
        :taggable="true"
      />
    </div>
    <mdb-input
      v-model="serviceData.startDatetime"
      size="lg"
      label="Start Datetime"
      type="datetime-local"
      outline
      required
    />
    <mdb-input
      v-model="serviceData.endDatetime"
      size="lg"
      label="End Datetime"
      type="datetime-local"
      outline
      required
    />

    <mdb-input
      v-model="serviceData.employees"
      size="lg"
      label="Employee(s)"
      type="text"
      outline
    />

    <mdb-input
      v-model="serviceData.notes"
      size="lg"
      type="textarea"
      label="Notes"
      outline
      :rows="5"
    />
    <mdb-btn color="primary" type="submit" class="float-right">
      Save
    </mdb-btn>
  </validated-form>
</template>

<script>
import moment from "moment";
import Multiselect from "vue-multiselect";
import { mdbInput, mdbBtn } from "mdbvue";
import ValidatedForm from "./ValidatedForm";
import { equipmentsModel } from "../models/equipment";
import { servicesModel } from "../models/service";
import { fieldsModel } from "../models/field";

export default {
  name: "FieldServiceForm",
  components: {
    mdbInput,
    mdbBtn,
    Multiselect,
    ValidatedForm
  },
  props: {
    farmId: {
      type: String,
      default: ""
    },
    fieldId: {
      type: String,
      default: ""
    },
    serviceId: {
      type: String,
      default: ""
    }
  },
  data() {
    const date = new Date();
    const dateFormat = 'YYYY-MM-DDTHH:mm:ss';
    return {
      fieldFormMessage: {},
      farmFields: [],
      activeFieldId: "",
      activeFieldSelection: {},
      activeServices: [],
      activeEquipment: [],
      serviceData: {
        id: "",
        reference: "",
        employees: "",
        notes: "",
        services: [],
        equipment: [],
        startDatetime: moment(date).format(dateFormat),
        endDatetime: moment(date).format(dateFormat)
      }
    };
  },
  beforeMount() {
    this.getActiveServices();
    this.getActiveEquipment();
    this.activeFieldId = this.fieldId;
    if (!this.fieldId) {
      this.getFields();
    }

    if (this.serviceId) {
      this.getService();
    }
  },
  methods: {
    setActiveFieldId(selectedOption) {
      this.activeFieldId = selectedOption.id;
    },

    handleFormSubmit() {
      this.fieldFormMessage = {};
      if(this.serviceId) {
        this.updateService();
      } else {
        this.saveService();
      }
    },

    getFields() {
      fieldsModel.getFields(this.farmId).then(fields => {
        this.farmFields = fields || [];
      });
    },

    getActiveServices() {
      servicesModel.list("name", "isActive", "==", true).then(services => {
        this.activeServices = services;
      });
    },

    getActiveEquipment() {
      equipmentsModel.list("name", "isActive", "==", true).then(equipment => {
        this.activeEquipment = equipment;
      });
    },
    getService() {
      fieldsModel.getService(this.fieldId, this.serviceId).then(serviceData => {
        this.serviceData = serviceData;
      });
    },
    updateService() {
      fieldsModel
        .updateService(this.activeFieldId, this.serviceId, this.serviceData)
        .then(() => {
          this.fieldFormMessage = {
            type: "success",
            message: "Field updated!"
          };
          this.$emit("savedService");
        })
        .catch(() => {
          this.fieldFormMessage = {
            type: "danger",
            message: "There was a problem updating. Please try again"
          };
        });
    },
    saveService() {
      fieldsModel
        .createService(this.activeFieldId, this.serviceData)
        .then(() => {
          this.fieldFormMessage = {
            type: "success",
            message: "Field Saved!"
          };
          this.$emit("savedService");
        })
        .catch(() => {
          this.fieldFormMessage = {
            type: "danger",
            message: "There was a problem updating. Please try again"
          };
        });
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tag {
  background: #085408 !important;
}
.multiselect__tag-icon {
  color: #fff !important;
}
</style>
